// initial state
const state = {
  status: [
    {value: 1, label: '等待开始'},
    {value: 2, label: '进行中'},
    {value: 3, label: '处理完成'},
    {value: 4, label: '撤回'},
    {value: -1, label: '已取消'},
    {value: -2, label: '失败'},
    {value: -3, label: '已删除'},
    {value: -4, label: '取消中'},
    {value: -5, label: '暂停中'},
    {value: -6, label: '已暂停'},
  ],
  approvalStatus: [
    {value: 0, label: '无需审批'},
    {value: 1, label: '待审批'},
    {value: 2, label: '已通过'},
    {value: 3, label: '已驳回'},
    {value: 4, label: '已放弃'},
  ],
}

export const taskBatch = {
  state,
}



// WEBPACK FOOTER //
// ./src/views/task-batch/task-batch.store.js